export default "__VITE_ASSET__DfzPdeFT__"